import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router";

// Components
import EmptyTemplate from "new_components/templates/states/EmptyTemplate";
import Text from "new_components/atoms/Text";
import Button from "new_components/atoms/Button";
import ZeroStateTemplate from "new_components/templates/ZeroStateScreen";

// Constants
import colors from "styles/colors";
import typography from "styles/typography";

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 8px;
`;

const EmptyPage = () => {
  const navigation = useNavigate();

  const TitleComponent = () => (
    <TextContainer>
      <Text
        typographyStyle={typography.emptyHeader.regular}
        color={colors.text.dark}
      >
        Build a
      </Text>
      <Text
        typographyStyle={typography.emptyHeader.bold}
        color={colors.primary[500]}
      >
        Pulse AI
      </Text>
      <Text
        typographyStyle={typography.emptyHeader.regular}
        color={colors.text.dark}
      >
        {" "}
        Survey
      </Text>
    </TextContainer>
  );

  return (
    <ZeroStateTemplate
      titleText="Build a"
      gradientText={"Pulse AI"}
      postGradientText={"Survey"}
      descriptionText="Use Pulse AI’s targeted pulse surveys to quickly identify key challenges and opportunities, fueling connected, high-performing teams in your workplace."
      ctaRow={
        <Button onClick={() => navigation("survey-selection")}>
          Start Gathering Insights
        </Button>
      }
    />
  );

  return (
    <EmptyTemplate
      heading="AI Toolkit"
      pageTitle="Pulse AI Surveys"
      titleComponent={<TitleComponent />}
      emptyText="Pulse AI keeps your team connected with targeted pulse surveys.  Gather real-time insights on engagement, morale and key issues to build a thriving workplace culture."
      actionRow={
        <Button onClick={() => navigation("survey-selection")}>
          Start Gathering Insights
        </Button>
      }
    />
  );
};

export default EmptyPage;
